import graphql from "babel-plugin-relay/macro";

import { useMutationWithError } from "../../../../../utils/hooks/useMutationWithError";
import { useCreatePhoneVerificationProfileMutation } from "./__generated__/useCreatePhoneVerificationProfileMutation.graphql";

export const useCreatePhoneVerificationProfile = () => {
  const [createVerification, isCreating] =
    useMutationWithError<useCreatePhoneVerificationProfileMutation>(
      useCreatePhoneVerificationProfileMutationString
    );

  const createPhoneVerification = (
    phoneNumber: string,
    onCompleteHandler: () => void
  ) => {
    createVerification({
      variables: { input: { phoneNumber } },
      onCompleted: (res) => {
        if (res.responsePayload?.success) {
          onCompleteHandler();
        }
      },
    });
  };
  return [createPhoneVerification, isCreating] as const;
};

export const useCreatePhoneVerificationProfileMutationString = graphql`
  mutation useCreatePhoneVerificationProfileMutation(
    $input: CreatePhoneVerificationInput!
  ) {
    responsePayload: createPhoneVerification(input: $input) {
      success
      errors {
        field
        code
        message
      }
    }
  }
`;
